import { useEffect, useState } from 'react';
import { customerService } from '@services/api/customerService';
import { formatCurrency, maskIBAN } from '@/types/customer';
import type { Account } from '@/types/customer';
import '../CustomerTabs.css';

interface AccountsTabProps {
  customerId: string;
}

export const AccountsTab = ({ customerId }: AccountsTabProps) => {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAccounts();
  }, [customerId]);

  const loadAccounts = async () => {
    const result = await customerService.getCustomerAccounts(customerId);
    if (result.success && result.data) {
      setAccounts(result.data);
    }
    setLoading(false);
  };

  if (loading) return <div>Loading accounts...</div>;
  if (accounts.length === 0) return <div>No accounts found</div>;

  return (
    <div className="tab-content-wrapper">
      {accounts.map((account) => (
        <div key={account.id} className="info-card">
          <h3 className="info-card-title">
            💰 {account.account_type} Account (****{account.account_number.slice(-4)})
          </h3>
          
          <div className="info-grid">
            <div className="info-item">
              <span className="info-label">Balance</span>
              <span className="info-value">{formatCurrency(Number(account.balance), account.currency)}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Available</span>
              <span className="info-value">{formatCurrency(Number(account.available_balance), account.currency)}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Status</span>
              <span className={`status-badge status-${account.status === 'ACTIVE' ? 'green' : 'red'}`}>
                {account.status}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">IBAN</span>
              <span className="info-value">{maskIBAN(account.iban)}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Opened</span>
              <span className="info-value">{account.opening_date || 'N/A'}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Currency</span>
              <span className="info-value">{account.currency}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

